<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 17 16"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8.5" cy="8" :fill="background" r="8"/>
    <rect height="8" rx="0.5" :stroke="fill" width="9" x="4" y="3.5"/>
    <path d="M5.5 12H7.5V12.5C7.5 12.7761 7.27614 13 7 13H6C5.72386 13 5.5 12.7761 5.5 12.5V12Z" :fill="fill"/>
    <path d="M9.5 12H11.5V12.5C11.5 12.7761 11.2761 13 11 13H10C9.72386 13 9.5 12.7761 9.5 12.5V12Z" :fill="fill"/>
    <rect :fill="fill" height="5" rx="1" width="6" x="5.5" y="5"/>
    <path clip-rule="evenodd" d="M8 8C8.27614 8 8.5 7.77614 8.5 7.5C8.5 7.22386 8.27614 7 8 7C7.72386 7 7.5 7.22386 7.5 7.5C7.5 7.77614 7.72386 8 8 8ZM8 9C8.82843 9 9.5 8.32843 9.5 7.5C9.5 6.67157 8.82843 6 8 6C7.17157 6 6.5 6.67157 6.5 7.5C6.5 8.32843 7.17157 9 8 9Z" :fill="background" fill-rule="evenodd"/>
    <rect :fill="background" height="2" rx="0.5" width="1" x="10" y="6.5"/>
  </svg>

</template>

<script>
export default {
  name: 'Archive',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    background: {
      type: String,
      required: false,
      default: '#344955'
    },
    fill: {
      type: String,
      required: false,
      default: '#FFF'
    },
  },
};

</script>
